import React from 'react'
import { Provider } from 'react-redux'
import Routers from '../../routers'
import configureStore from '../../store/configureStore'

const store = configureStore()

const App = () => (
  <Provider store={store}>
    <Routers />
  </Provider>
)

export default App


// WEBPACK FOOTER //
// ./src/containers/App/App.prod.js